/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalDocumentToSubmit } from './PalDocumentToSubmit';
import {
    PalDocumentToSubmitFromJSON,
    PalDocumentToSubmitFromJSONTyped,
    PalDocumentToSubmitToJSON,
} from './PalDocumentToSubmit';

/**
 * 
 * @export
 * @interface AddDocumentToPalAuthSubmission201Response
 */
export interface AddDocumentToPalAuthSubmission201Response {
    /**
     * 
     * @type {PalDocumentToSubmit}
     * @memberof AddDocumentToPalAuthSubmission201Response
     */
    data?: PalDocumentToSubmit;
}

/**
 * Check if a given object implements the AddDocumentToPalAuthSubmission201Response interface.
 */
export function instanceOfAddDocumentToPalAuthSubmission201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AddDocumentToPalAuthSubmission201ResponseFromJSON(json: any): AddDocumentToPalAuthSubmission201Response {
    return AddDocumentToPalAuthSubmission201ResponseFromJSONTyped(json, false);
}

export function AddDocumentToPalAuthSubmission201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddDocumentToPalAuthSubmission201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : PalDocumentToSubmitFromJSON(json['data']),
    };
}

export function AddDocumentToPalAuthSubmission201ResponseToJSON(value?: AddDocumentToPalAuthSubmission201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': PalDocumentToSubmitToJSON(value.data),
    };
}

